<mat-toolbar class="topbar">
  <!-- --------------------------------------------------------------- -->
  <!-- Desktop Menu -->
  @if(showToggle) {
  <button
    mat-icon-button
    (click)="toggleCollapsed.emit()"
    class="d-flex justify-content-center"
  >
    <i-tabler name="menu-2" class="icon-20 d-flex"></i-tabler>
  </button>
  }

  <!-- Mobile Menu -->
  @if(!showToggle) {
  <button
    mat-icon-button
    (click)="toggleMobileNav.emit()"
    class="d-flex justify-content-center"
  >
    <i-tabler name="menu-2" class="icon-20 d-flex"></i-tabler>
  </button>
  }
  <!-- --------------------------------------------------------------- -->

  <span class="flex-1-auto"></span>

  <!-- Mobile Menu -->
  <button
    mat-icon-button
    (click)="toggleMobileFilterNav.emit()"
    class="d-flex d-lg-none justify-content-center"
  >
    <i-tabler name="grid-dots" class="icon-20 d-flex"></i-tabler>
  </button>


  <a
    mat-icon-button
    routerLink="/apps/users/account"
    aria-label="Account settings"
    class="header-settings-btn"
  >
    <i-tabler name="settings" class="icon-16 d-flex"></i-tabler>
  </a>

  <!-- --------------------------------------------------------------- -->
  <!-- profile Dropdown -->
  <!-- --------------------------------------------------------------- -->
  <button
    mat-icon-button
    [matMenuTriggerFor]="profilemenu"
    aria-label="Profile"
    class="header-avatar-btn"
  >
    <img
      *ngIf="avatarUrl"
      [src]="avatarUrl"
      class="rounded-circle object-cover"
      width="32"
      height="32"
      alt=""
    />
    <span *ngIf="!avatarUrl" class="header-avatar-initials">{{ userInitials }}</span>
  </button>
  <mat-menu #profilemenu="matMenu" class="profile-menu cardWithShadow" xPosition="before">
    <div class="profile-menu-head">
      <img
        *ngIf="avatarUrl"
        [src]="avatarUrl"
        class="profile-menu-avatar"
        alt=""
      />
      <span *ngIf="!avatarUrl" class="profile-menu-avatar profile-menu-avatar--initials">{{ userInitials }}</span>
      <div class="profile-menu-meta">
        <div class="profile-menu-name">{{ user.first_name }} {{ user.last_name }}</div>
        <div class="profile-menu-role" *ngIf="user.role">{{ user.role }}</div>
        <div class="profile-menu-email" *ngIf="user.email">
          <i-tabler name="mail" class="icon-15"></i-tabler>
          {{ user.email }}
        </div>
      </div>
    </div>

    <div class="profile-menu-links">
      @for(profile of profiledd; track profile.title) {
      <a class="profile-menu-link" [routerLink]="[profile.link]">
        <span class="profile-menu-link-icon">
          <img [src]="profile.img" width="16" alt="" />
        </span>
        <span class="profile-menu-link-text">
          <span class="profile-menu-link-title">{{ profile.title }}</span>
          <span class="profile-menu-link-sub">{{ profile.subtitle }}</span>
        </span>
      </a>
      }
    </div>

    <div class="profile-menu-actions">
      <a
        [routerLink]="['/authentication/login']"
        mat-stroked-button
        color="primary"
        class="profile-menu-logout"
      >Logout</a>
    </div>
  </mat-menu>
</mat-toolbar>
